export default "__VITE_ASSET__UwDTAq1x__"